import React, { type JSX } from "react";
import { useCallStore } from "../../../stores/call/useCallStore";
import RoomTile from "./RoomTile";

function RoomTileContainer(props: React.ComponentProps<typeof RoomTile>): JSX.Element {
    const {inCall, callRoom} = useCallStore();
    return <RoomTile {...props} inCall={inCall} callRoom={callRoom} />;
}

export default RoomTileContainer;
